import { render } from "./TaskSummary.vue?vue&type=template&id=70da696d&scoped=true"
import script from "./TaskSummary.vue?vue&type=script&lang=js"
export * from "./TaskSummary.vue?vue&type=script&lang=js"

import "./TaskSummary.vue?vue&type=style&index=0&id=70da696d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70da696d"]])

export default __exports__